import { User } from './../user/types';
import { CardEvent } from 'src/store/events/types';

import { Station } from '../events/types';
import { Bike } from './../bus/types';
import { Bus } from './../events/types';

export interface Participation {
  id: number;
  participant: Participant;
  cardevent?: CardEvent;
  bus?: Bus;
  station?: Station;
  bike?: Bike;
}

export interface Participant {
  id: number;
  firstname: string;
  lastname: string;
  phonenumber: string;
  isChild: boolean;
  isStaff: boolean;
  age?: number;
  eventId?: number;
  bikeType?: string;
  station?: Station;
  creator?: User;
}

export interface RegisterParticipant {
  firstname: string;
  lastname: string;
  phonenumber: string;
  isChild: boolean;
  isStaff: boolean;
  age: number;
  eventId: number;
  stationId?: number;
  biketype?: string;
  creatorId?: string;
}

export enum ParticipantActionTypes {
  REGISTER_REQUEST = '[participant]REGISTER_REQUEST',
  REGISTER_SUCCESS = '[participant]REGISTER_SUCCESS',
  REGISTER_ERROR = '[participant]REGISTER_ERROR',

  REQUEST = '[participant]REQUEST',
  DELETE_SUCCESS = '[participant]DELETE_SUCCESS',
  ERROR = '[participant]ERROR',

  UPDATE_SUCCESS = '[participant]UPDATE_SUCCESS'
}

export interface IParticipantData {
  byId: { [id: number]: Participant };
  allIds: number[];
  byEvent: { [id: number]: { [day: number]: number[] } };
}

export interface ParticipantState {
  readonly loading: boolean;
  readonly data: IParticipantData;
  readonly errors?: Error;
}



// WEBPACK FOOTER //
// ./src/store/participant/types.ts